import {useSelector} from "react-redux";
import moment from "moment";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

import {dateFormat} from "@/utils/constants";
import {useCategories} from "@/utils/hooks";

import "./index.scss";

export default function MatchCard(props) {
	const {element, type} = props;

	const {categories} = useCategories({
		setLoading: false,
		handleNotification: undefined,
	});
	const userRole = useSelector((state) => state?.user?.roleName);

	// NEW: calcolo se il match è finito
	const start = element?.startDate || element?.matchDate;
	const duration = Number.isFinite(element?.matchMinutes)
		? element.matchMinutes
		: 90;
	const isFinished = start
		? moment().isAfter(moment(start).add(duration, "minutes"))
		: false;

	// NEW: stringa risultato pronta, ma usata solo se isFinished
	const goalsKnown =
		element?.homeClubGoals !== null &&
		element?.homeClubGoals !== undefined &&
		element?.awayClubGoals !== null &&
		element?.awayClubGoals !== undefined;

	const resultString = element?.composedResult
		? element.composedResult
		: goalsKnown
			? `${element.homeClubGoals} - ${element.awayClubGoals}`
			: "";

	let matchTypeIcon = "";
	switch (element.matchType) {
		case "Torneo":
		case "Coppa":
			matchTypeIcon = require("@/assets/images/coach/trophy.png");
			break;
		case "Amichevole":
			matchTypeIcon = require("@/assets/images/coach/match.png");
			break;
		case "Campionato":
			matchTypeIcon = require("@/assets/images/coach/league.png");
			break;
		default:
			break;
	}

	let matchConvocationStatus = <></>;
	switch (element.convocationStatus) {
		case "Presente":
			matchConvocationStatus = <div className="cell on" />;
			break;
		case "Assente":
		case "Non convocato":
			matchConvocationStatus = <div className="cell off" />;
			break;
		case "Infortunato":
			matchConvocationStatus = <LocalHospitalIcon color="error" />;
			break;
		default:
	}

	const matchCategory = categories?.filter(
		(c) => c.id === element?.playersCategoryId,
	)?.[0];
	const hasRPE = !matchCategory?.isBasicActivities;

	return (
		<div className="match-card-container">
			<div className="d-flex flex-column">
				<div className="match-card-header">
					<div className="top-left">
						{moment(start).format(dateFormat + " HH:mm")}
					</div>

					<div className="top-right">
						{type === "scouting_match" ? (
							<div className="targets-container">
								<img
									src={require("@/assets/images/manager/target.png")}
									alt=""
								/>
								<div>{element.prospectsObserved?.length}</div>
							</div>
						) : (
							element.playersCategory
						)}
					</div>
				</div>
				{type === "match_calendar" ? (
					<div className="top-center">
						<div className="match-counter">
							<div className="counter">{element.round || "---"}</div>
						</div>
					</div>
				) : null}
			</div>
			<div className="match-card-info">
				<div className="info-title">
					{type !== "scouting_match"
						? (element.homeClub || "---") + " - " + (element.awayClub || "---")
						: element.playersCategory}
				</div>
				<div className="info-subtitle">
					{type !== "scouting_match"
						? // NEW: mostra risultato solo se finito
							isFinished
							? resultString
							: "---"
						: (element.homeClub || "---") + " - " + (element.awayClub || "---")}
				</div>
			</div>
			{type !== "scouting_match" ? (
				<>
					<div className="separator"></div>
					<div className="match-card-preview">
						<div className="match-type">
							<img src={matchTypeIcon} alt="" />
							<div className="type-info">{element.matchType}</div>
						</div>
						{type === "match_player" ? (
							<>
								<div className="match-status">{matchConvocationStatus}</div>
								<div className="match-stats">
									<div className="single-stat">
										<img
											src={require("@/assets/images/coach/time.png")}
											alt=""
										/>
										<div>
											{element.minutesPlayed !== null &&
											element.minutesPlayed !== undefined
												? element.minutesPlayed + "/" + element.matchMinutes
												: "---"}
										</div>
									</div>
									<div className="single-stat">
										<img
											src={require("@/assets/images/coach/football.png")}
											alt=""
										/>
										<div>
											{element.goalsConceded !== null &&
											element.goalsConceded !== undefined
												? element.goalsConceded +
													"/" +
													element.totalGoalsConceded
												: "---"}
										</div>
									</div>
								</div>
							</>
						) : (
							<>
								{userRole !== "Player" ? (
									<div className="match-stats">
										<div className="single-stat">
											<img
												src={require("@/assets/images/manager/movement_player.png")}
												alt=""
											/>
											<div>{element.matchConvocations?.length || 0}</div>
										</div>
										{hasRPE && (
											<div className="single-stat">
												<img
													src={require("@/assets/images/coach/rpe.png")}
													alt=""
												/>
												<div>{element.matchRpe?.length || 0}</div>
											</div>
										)}
										<div className="single-stat">
											<img
												src={require("@/assets/images/coach/analysis.png")}
												alt=""
											/>
											<div>{element.matchEvaluations?.length || 0}</div>
										</div>
									</div>
								) : hasRPE ? (
									<div className="match-stats">
										<div className="single-stat">
											<div>RPE</div>
											<div
												className={
													"value" +
													(element.matchRpe?.length ? " inserted" : " empty")
												}
											></div>
										</div>
									</div>
								) : (
									<></>
								)}
							</>
						)}
					</div>
				</>
			) : (
				<>
					<div className="separator"></div>
					<div className="match-card-preview">
						<div className="match-type">
							<div className="type-info">{element.fieldName}</div>
						</div>
						<div className="match-scouts">
							<div className="scout">
								<img
									src={require("@/assets/images/manager/staff.png")}
									alt=""
								/>
								<div>{element.scoutNames || "---"}</div>
							</div>
						</div>
					</div>
				</>
			)}
		</div>
	);
}
